export * from './Highlighter'
export * from './HighlighterComponent'
export * from './HighlighterIndicator'


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/highlighter/index.ts